import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DeletePopupComponent } from "../delete-popup/delete-popup.component";
import { HttpService } from "src/app/services/http/http.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "app-allergensdietary",
  templateUrl: "./allergensdietary.component.html",
  styleUrls: ["./allergensdietary.component.scss"],
})
export class AllergensdietaryComponent implements OnInit {
  allegenList: any[] = [];
  dataSource: MatTableDataSource<[]> = new MatTableDataSource(this.allegenList);
  constructor(
    public dialog: MatDialog,
    private httpsv: HttpService,
    private _snackBar: MatSnackBar
  ) {}
  @ViewChild("paginator", { read: MatPaginator }) paginator: MatPaginator;
  ngOnInit(): void {
    this.getAllergenList();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  displayedColumns: string[] = ["SL-NO", "name", "edit", "action"];
  dataSourceCopy: any[] = this.allegenList;
  searchText: any;
  allergensSlectedFlag = true;
  dietarySlectedFlag = false;
  lengthAllergens: number;
  filter() {
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.allegenList);
      this.dataSource.paginator = this.paginator;
    } else {
      let temp = this.dataSourceCopy.filter((ele) => {
        return ele.allergens_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);
      this.dataSource.paginator = this.paginator;
    }
  }
  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "allergens",
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == "true") {
          let data = { id: id };
          this.httpsv.deleteAllergen(data).subscribe((res) => {
            if (res["status"] == "TRUE") {
              this.getAllergenList();
              this._snackBar.open("Allergen Deleted");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          });
        }
      },
      (err: any) => {
        this._snackBar.open("Oops! Something went wrong");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
        console.log(err);
      }
    );
  }
  allergensSelectFunc() {
    this.allergensSlectedFlag = true;
    this.dietarySlectedFlag = false;
    this.getAllergenList();
  }
  dietarySlectFunc() {
    this.allergensSlectedFlag = false;
    this.dietarySlectedFlag = true;
  }
  addAllergens() {
    const dialogRef = this.dialog.open(AddAllergens, {
      width: "700px",
      data: "Alleregns",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "false" || result == undefined || result == "") {
        // console.log(result);
      } else {
        let data = { name: result };
        this.httpsv.createAllergen(data).subscribe(
          (res: any) => {
            if (res["status"] == "TRUE") {
              this.getAllergenList();
              this._snackBar.open("Alleregen is added");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            // console.log(err.error.message)
            this._snackBar.open(err.error.message);
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
            console.log(err);
          }
        );
      }
      // console.log(result);
    });
  }
  editDialog(id) {
    const dialogRef = this.dialog.open(UpdateAllergens, {
      width: "550px",
      data: {
        text: "Allergens",
        mainData: this.dataSourceCopy.filter((ele) => id == ele.id)[0][
          "allergens_name"
        ],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "false" || result == undefined || result == "") {
      } else {
        let updateData = {
          id: id,
          name: result,
        };
        this.httpsv.updateAllergen(updateData).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.getAllergenList();
              this._snackBar.open("Allergen is updated");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            this._snackBar.open("Oops! Something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
            console.log(err);
          }
        );
      }
    });
  }
  getAllergenList() {
    this.httpsv.getAlergensList().subscribe(
      (res) => {
        if (res["status"] == "TRUE") {
          this.allegenList = res["result"].data;
          this.dataSource.data = res["result"].data;
          this.dataSource.paginator = this.paginator;
          this.dataSourceCopy = res["result"].data;
          this.lengthAllergens = this.dataSourceCopy.length;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
}

@Component({
  selector: "app-dialog",
  templateUrl: "./add-allergens-dialog.html",
})
export class AddAllergens {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  text = this.data;
  noAlleregns = [1];
  inputValue = "";
  addInput() {
    this.noAlleregns.push(1);
  }
}
@Component({
  selector: "update-dialog",
  templateUrl: "./update-allergens.html",
})
export class UpdateAllergens {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  value = this.data.mainData;
  text = this.data.text;
}

@Component({
  selector: "app-diet",
  templateUrl: "./diet.html",
})
export class Diet implements OnInit {
  dietaryList: any[] = [];
  dietaryData: MatTableDataSource<[]> = new MatTableDataSource(
    this.dietaryList
  );
  displayedColumns: string[] = ["SI-NO", "name", "edit", "action"];
  @ViewChild("paginator2", { read: MatPaginator }) paginator2: MatPaginator;
  ngOnInit(): void {
    this.listDietaryPreference();
  }
  ngAfterViewInit(): void {
    this.dietaryData.paginator = this.paginator2;
  }
  constructor(
    public dialog: MatDialog,
    private httpsv: HttpService,
    private _snackBar: MatSnackBar
  ) {}
  searchText: any;
  dataSourceCopy: any[] = this.dietaryList;
  lengthDietary: number;
  filter() {
    if (this.searchText == "") {
      this.dietaryData = new MatTableDataSource(this.dietaryList);
      this.dietaryData.paginator = this.paginator2;
    } else {
      let temp = this.dataSourceCopy.filter((ele) => {
        return ele.name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dietaryData = new MatTableDataSource(temp);
      this.dietaryData.paginator = this.paginator2;
    }
  }
  editDialog(id) {
    const dialogRef = this.dialog.open(UpdateAllergens, {
      width: "550px",
      data: {
        text: "Allergens",
        mainData: this.dataSourceCopy.filter((ele) => id == ele.id)[0]["name"],
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "false" || result == undefined || result == "") {
      } else {
        const data = {
          id: id,
          name: result,
        };
        this.httpsv.updateDietaryPrefer(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.listDietaryPreference();
              this._snackBar.open("Dietary preference is updated");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            this._snackBar.open("Oops! Something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
            console.log(err);
          }
        );
      }
    });
  }
  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "allergens",
    });
    dialogRef.afterClosed().subscribe((result) => {
      const data = {
        id: id,
      };
      if (result == "true") {
        this.httpsv.deleteDietaryPrefer(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.listDietaryPreference();
              this._snackBar.open("Dietary preference is deleted");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            this._snackBar.open("Oops! Something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        );
      }
      // console.log(result);
    });
  }
  addAllergens() {
    const dialogRef = this.dialog.open(AddAllergens, {
      width: "700px",
      data: "Dieatry Prefernce",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "false" || result == undefined || result == "") {
        // console.log("not");
      } else {
        let data = { name: result };
        this.httpsv.createDietaryPrefer(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this.listDietaryPreference();
              this._snackBar.open("Dietary preference is added");
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
            // console.log(res);
          },
          (err: any) => {
            this._snackBar.open("Oops! Something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        );
      }
    });
  }
  listDietaryPreference() {
    this.httpsv.getDietaryList().subscribe((res) => {
      if (res["status"] == "TRUE") {
        this.dietaryList = res["result"].data;
        this.dietaryData.data = res["result"].data;
        this.dietaryData.paginator = this.paginator2;
        this.dataSourceCopy = res["result"].data;
        this.lengthDietary = this.dataSourceCopy.length;
      }
    });
  }
}
